import * as React from 'react';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgRemoveShoppingCart = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "10 10 22 22",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M32 30.77 12.681 11.453l-.745-.745-.707-.707L10 11.23l4.249 4.248 2.139 4.51-1.307 2.372a1.87 1.87 0 0 0-.242.929c0 1.065.871 1.936 1.936 1.936h7.22l1.336 1.335c-.484.349-.803.92-.803 1.569 0 1.064.861 1.935 1.926 1.935.648 0 1.22-.32 1.568-.813L30.771 32 32 30.77ZM17.182 23.29a.24.24 0 0 1-.242-.242l.029-.116.87-1.578h2.285l1.936 1.936h-4.878Zm7.869-1.936c.726 0 1.364-.397 1.693-.997l3.465-6.281a.97.97 0 0 0-.852-1.432H16.33l8.72 8.71Zm-8.276 4.84a1.933 1.933 0 0 0-1.926 1.935c0 1.065.861 1.936 1.926 1.936a1.941 1.941 0 0 0 1.936-1.936 1.941 1.941 0 0 0-1.936-1.935Z",
  style: {
    fill: "currentColor"
  }
}));

export { SvgRemoveShoppingCart as default };
